/** Значки провайдеров входа (упрощённые монограммы в фирменных цветах). */
const MARKS: Record<string, { bg: string; fg: string; text: string }> = {
  google: { bg: '#ffffff', fg: '#4285f4', text: 'G' },
  github: { bg: '#24292f', fg: '#ffffff', text: 'GH' },
  yandex: { bg: '#fc3f1d', fg: '#ffffff', text: 'Я' },
  microsoft: { bg: '#2f2f2f', fg: '#ffffff', text: 'MS' },
  discord: { bg: '#5865f2', fg: '#ffffff', text: 'D' },
};

export function ProviderIcon({ id }: { id: string }) {
  const m = MARKS[id] ?? { bg: 'var(--surface-2)', fg: 'var(--text)', text: id.slice(0, 1).toUpperCase() };
  return (
    <span className="provider-icon" style={{ background: m.bg, color: m.fg }} aria-hidden="true">
      {m.text}
    </span>
  );
}
